import { useState } from "react";
import Seo from "@/components/Seo";
import { Reveal, MaskLine } from "@/components/Reveal";
import ContactBlock from "@/components/ContactBlock";
import ArticleCard from "@/components/ArticleCard";
import { ARTICLES, CATEGORIES } from "@/data/content";

const Conseils = () => {
  const [cat, setCat] = useState("Tous");
  const filtered = cat === "Tous" ? ARTICLES : ARTICLES.filter((a) => a.category === cat);

  return (
    <>
      <Seo
        title="Conseils facturation infirmière | Guides pour infirmiers indépendants — AVELIS"
        description="Guides pratiques pour les infirmiers indépendants en Belgique : tarification infirmière, rejets de facturation, informations à transmettre, coût d'un office de tarification."
      />

      <section className="pt-[130px] sm:pt-[160px] pb-12 sm:pb-16 bg-[#f6f3ec]">
        <div className="container-avelis">
          <p className="eyebrow"><span className="dot-sage" />Conseils</p>
          <h1 className="mt-5 max-w-3xl text-4xl sm:text-5xl lg:text-[3.4rem] font-extrabold tracking-tight leading-[1.08] text-[#0d2731]">
            <MaskLine delay={0.1}>Conseils & repères</MaskLine>
            <MaskLine delay={0.25}>pour votre facturation.</MaskLine>
          </h1>
          <Reveal delay={0.35}>
            <p className="lead-avelis mt-6 max-w-2xl">
              Des guides pratiques qui répondent aux vraies questions des infirmiers indépendants : rejets, organisation, transmission, coûts.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="blog-section" className="pb-16 sm:pb-24 bg-[#f6f3ec]">
        <div className="container-avelis">
          <Reveal>
            <div className="flex flex-wrap gap-2.5" role="group" aria-label="Filtrer par catégorie">
              {CATEGORIES.map((c) => (
                <button
                  key={c}
                  data-testid={`blog-filter-${c.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  onClick={() => setCat(c)}
                  aria-pressed={cat === c}
                  className={`rounded-full px-4 py-2 text-xs font-bold tracking-wide transition-colors duration-200 border ${
                    cat === c
                      ? "bg-[#0d2731] text-[#f6f3ec] border-[#0d2731]"
                      : "bg-white text-[#4b585e] border-[#e5e1d8] hover:border-[#176b70] hover:text-[#176b70]"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
          </Reveal>

          {filtered.length === 0 ? (
            <p data-testid="blog-empty" className="mt-12 text-sm text-[#4b585e]">
              Aucun contenu dans cette catégorie pour le moment. De nouveaux conseils seront publiés prochainement.
            </p>
          ) : (
            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl">
              {filtered.map((a, i) => (
                <Reveal key={a.slug} delay={i * 0.08}>
                  <ArticleCard article={a} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>

      <ContactBlock />
    </>
  );
};

export default Conseils;
